var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.9299C13.7231 13.9299 15.12 12.5331 15.12 10.8099C15.12 9.08681 13.7231 7.68994 12 7.68994C10.2769 7.68994 8.88 9.08681 8.88 10.8099C8.88 12.5331 10.2769 13.9299 12 13.9299Z",
    stroke: "#818181",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62 8.99C5.59 0.330002 18.42 0.340003 20.38 9C21.53 14.08 18.37 18.38 15.6 21.04C13.59 22.98 10.41 22.98 8.39 21.04C5.63 18.38 2.47 14.07 3.62 8.99Z",
    stroke: "#818181",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.71e212564e538034accafa8501947d4c.svg";
export { ForwardRef as ReactComponent };